import { withProfiler } from "@sentry/react";
import type { FC } from "react";

import { cookieExtractor } from "@shared/helpers";
import type { Flipper } from "@shared/types/flipper";
import type { PractitionerType } from "@unauthenticated/shared/data/types";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";

import { Pages } from "./Pages";

interface Props {
  currentCountry: string;
  practitionerTypes: PractitionerType[];
  emailRegex: string;
  signUpAdditionalAttributes?: any;
  signInAdditionalAttributes?: any;
  csuid: string;
  flippers: Flipper[];
  newSSOErrors?: string;
  authErrors?: string;
  isFromWellevate?: boolean;
  isFromEmersonEcologics?: boolean;
  e2e: boolean;
}

const AuthLandingPage: FC<Props> = ({
  currentCountry,
  practitionerTypes,
  emailRegex,
  signUpAdditionalAttributes,
  signInAdditionalAttributes,
  csuid,
  flippers,
  newSSOErrors,
  authErrors,
  isFromWellevate,
  isFromEmersonEcologics,
  e2e,
}) => {
  const pageVersion = "prac_by_default_with_sso";

  const {
    _gid: googleId,
    _biz_uid: bizibleId,
    _ga: googleAnalyticsId,
  } = cookieExtractor(["_gid", "_ga", "_biz_uid"]);

  const optionalAttributesForSignUp = {
    ...signUpAdditionalAttributes,
    bizibleId,
    googleId,
    googleAnalyticsId,
  };

  return (
    <Providers
      {...{ emailRegex, currentCountry, flippers, isFromWellevate, isFromEmersonEcologics, e2e }}
    >
      <ErrorBoundary {...{ csuid, flippers, pageVersion }}>
        <Pages
          practitionerTypes={practitionerTypes}
          signUpAdditionalAttributes={optionalAttributesForSignUp}
          signInAdditionalAttributes={signInAdditionalAttributes}
          csuid={csuid}
          newSSOErrors={newSSOErrors}
          authErrors={authErrors}
          pageVersion={pageVersion}
        />
      </ErrorBoundary>
    </Providers>
  );
};

const AuthLandingPageWithProfiler = withProfiler(AuthLandingPage);
export { AuthLandingPageWithProfiler as AuthLandingPage };
